// extracted by mini-css-extract-plugin
module.exports = {"cards":"SpacesPage_cards__1Q_2Q","controls":"SpacesPage_controls__22KmJ","sort":"SpacesPage_sort__1IPSX"};